import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AppState } from 'src/app/core/core.state';
import { NotificationService } from 'src/app/core/notification.service';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';

import { operationSelectors } from './operation.selectors';

@Injectable({
  providedIn: 'root'
})
export class OperationsGuard  {
  constructor(
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private router: Router
  ) {}

  canActivate(): Observable<any> {
    return this.store.pipe(
      select(operationSelectors.selectAll),
      map((operations) => {
        if (!operations.length) {
          return true
        }

        if (operations.find((x) => x.isPending)) {
          return this.router.parseUrl('/operations')
        }

        return true
      }),
      take(1)
    )
  }
}
